var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.334 6.333V4.439A3.778 3.778 0 0 0 23.56.666H4.44A3.778 3.778 0 0 0 .667 4.439v11.787a3.778 3.778 0 0 0 3.773 3.773h19.12a3.779 3.779 0 0 0 3.774-3.773v-4.56c0-.547-.454-1-1-1-.547 0-1 .453-1 1v4.56c0 .973-.8 1.773-1.774 1.773H4.44c-.973 0-1.773-.8-1.773-1.773V7.333h23.667c.546 0 1-.454 1-1zM4.44 2.666h19.12c.974 0 1.774.8 1.774 1.773v.894H2.667v-.894c0-.973.8-1.773 1.773-1.773z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.533 13.332c-.546 0-1 .453-1 1 0 .547.454 1 1 1h3.814c.546 0 1-.453 1-1 0-.547-.44-1-1-1H5.533z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagamento);
export default __webpack_public_path__ + "static/media/pagamento.0409e31b5bad08f547c8ccf2c9974ec3.svg";
export { ForwardRef as ReactComponent };